import { Link } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

export interface BreadcrumbItem {
  label: string
  to?: string
}

interface BreadcrumbProps {
  items: BreadcrumbItem[]
}

export function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav className="flex items-center gap-1.5 text-sm">
      {items.map((item, i) => (
        <span key={i} className="flex items-center gap-1.5">
          {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-[#555A73]" strokeWidth={1.25} />}
          {item.to ? (
            <Link to={item.to} className="text-[#8B8FA7] hover:text-white transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-[#1B2559] font-medium">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  )
}
